import React from 'react'
import { Container, Description, Title } from './FormFinish.styles'
import { ReactComponent as SuccessWelbe } from 'App/assets/success-welbe.svg'

export const FeedbackUser = () => {
	return (
		<Container>
			<Title>Campaña NOM-035</Title>
			<SuccessWelbe />
			<Description variant>
				¡Te agradece por participar en las evaluaciones!
			</Description>
			<Description>
				Analizaremos los resultados generales para llevar a cabo planes de
				acción y mejoras en tu entorno laboral.
			</Description>
		</Container>
	)
}
